import _ from 'underscore';
import {
  getComponentById,
  DATA_SOURCE_KEY_MAPPING,
  getDataSourceByKey,
  getDefaultHoursConfig,
} from '@bingads-webui-campaign-react/smart-component-util';

// to support saved siteConfig with hours in dataSource
// read component config for businessHours first
// then fallback to read from dataSource key
// then fallback to default hours
export const proxyReadHoursConfig = (siteConfig, id) => {
  const componentConfig = getComponentById(siteConfig, id);
  const defaultHours = getDefaultHoursConfig();
  const cmpHours = _.propertyOf(componentConfig)(DATA_SOURCE_KEY_MAPPING.BusinessHours);
  const dsHours = getDataSourceByKey(siteConfig, DATA_SOURCE_KEY_MAPPING.BusinessHours);

  let hours = defaultHours;
  if (!_.isEmpty(cmpHours)) {
    hours = cmpHours;
  } else if (!_.isEmpty(dsHours)) {
    hours = dsHours;
  }

  return {
    fromDs: !_.isEmpty(dsHours),
    hours,
  };
};
